(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["monom-bestseller"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.mnb__griglia');
    const previous = section.querySelector('.mnb__prev');
    const next = section.querySelector('.mnb__next');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      section.style.setProperty('--mn-progress', String(max > 4 ? Math.max(0, Math.min(1, track.scrollLeft / max)) : 0));
      section.classList.toggle('is-scorribile', max > 4);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    const move = (direction) => {
      const card = track.querySelector('.mnb__cell');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      if (card) track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: motion.matches ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1), options);
    next.addEventListener('click', () => move(1), options);
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    }, options);
    track.addEventListener('scroll', update, { passive: true, signal: controller.signal });
    const observer = new ResizeObserver(update);
    observer.observe(track);
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('.mnb__cell');
      if (card && section.contains(card)) track.scrollTo({ left: card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - parseFloat(getComputedStyle(track).paddingLeft), behavior: 'auto' });
    }, options);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(section)) return;
      observer.disconnect();
      controller.abort();
    }, options);
    update();
  };
  const initAll = () => document.querySelectorAll('[data-mnb]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monom-formati"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.mnf__track');
    const previous = section.querySelector('.mnf__freccia--sx');
    const next = section.querySelector('.mnf__freccia--dx');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      section.style.setProperty('--mn-progress', String(max > 4 ? Math.max(0, Math.min(1, track.scrollLeft / max)) : 0));
      section.classList.toggle('is-scorribile', max > 4);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    const move = (direction) => {
      const card = track.querySelector('.mnf__cell');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      if (card) track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: motion.matches ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1), options);
    next.addEventListener('click', () => move(1), options);
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    }, options);
    track.addEventListener('scroll', update, { passive: true, signal: controller.signal });
    const observer = new ResizeObserver(update);
    observer.observe(track);
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('.mnf__cell');
      if (card && section.contains(card)) track.scrollTo({ left: card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - parseFloat(getComputedStyle(track).paddingLeft), behavior: 'auto' });
    }, options);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(section)) return;
      observer.disconnect();
      controller.abort();
    }, options);
    update();
  };
  const initAll = () => document.querySelectorAll('[data-mnf]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monom-hero-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.mnh__track');
    const slides = [...track.children];
    const nav = section.querySelector('.mnh__nav');
    const buttons = [...section.querySelectorAll('[data-slide]')];
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let frame;
    const position = (slide) => slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    const go = (index, immediate = false) => {
      const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
      if (slide) track.scrollTo({ left: position(slide), behavior: immediate || motion.matches ? 'auto' : 'smooth' });
    };
    const update = () => {
      const scrollable = track.scrollWidth > track.clientWidth + 4;
      if (nav) nav.hidden = !scrollable;
      current = slides.reduce((best, slide, index) => Math.abs(position(slide) - track.scrollLeft) < Math.abs(position(slides[best]) - track.scrollLeft) ? index : best, 0);
      buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === current)));
      slides.forEach((slide, index) => { slide.inert = scrollable && index !== current; });
    };
    buttons.forEach((button, index) => button.addEventListener('click', () => go(index), options));
    track.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true, signal: controller.signal });
    const observer = new ResizeObserver(() => { go(current, true); update(); });
    observer.observe(track);
    document.addEventListener('shopify:block:select', (event) => {
      const index = slides.indexOf(event.target.closest('.mnh__slide'));
      if (index !== -1) go(index, true);
    }, options);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(section)) return;
      observer.disconnect();
      cancelAnimationFrame(frame);
      controller.abort();
    }, options);
    update();
  };
  const initAll = () => document.querySelectorAll('[data-mnh]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
